import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themetwo/afiliado_3.png'


const _hoisted_1 = {
  key: 0,
  class: "note_text"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'graphCard',
  props: {
    isShowNotice: {
        type: Boolean,
        default: () => false
    },
    textColors:{
        type: Object
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card_body",
    style: _normalizeStyle(__props.textColors && __props.textColors.backgroundColor ? { background: __props.textColors.backgroundColor } : {})
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(__props.textColors ? { color: __props.textColors.titleColor, backgroundColor: __props.textColors.backgroundColor } : {}),
      class: "card_title"
    }, _toDisplayString(_ctx.$t('agent.graphCardTitle')), 5),
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    (props.isShowNotice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.$t('agent.graphCardContent1')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('agent.graphCardContent2')), 1),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('agent.graphCardContent3')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})